import React from 'react';
import Chart from 'react-apexcharts';

const SpecialityAreaChart = () => {
  const series = [
    {
      name: 'Active Resource',
      data: [31, 40, 28, 51, 42, 109, 100],
    },
  ];

  const options = {
    chart: {
      fontFamily: "Plus Jakarta Sans, sans-serif",
      height: 350,
      type: 'area',
      toolbar: {
        show: false,
      },
    },
    grid: {
      show: false,
    },
    colors: ['#5C9FFF'], // Single series color
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: 'smooth',
    },
    xaxis: {
      type: 'datetime',
      categories: [
        '2023-01-01T00:00:00.000Z',
        '2023-02-01T00:00:00.000Z',
        '2023-03-01T00:00:00.000Z',
        '2023-04-01T00:00:00.000Z',
        '2023-05-01T00:00:00.000Z',
        '2023-06-01T00:00:00.000Z',
        '2023-07-01T00:00:00.000Z',
      ],
      labels: {
        style: {
          colors: Array(7).fill('#a1aab2'),
        },
        datetimeFormatter: {
          month: 'MMM',
        },
      },
    },
    yaxis: {
      labels: {
        style: {
          colors: Array(7).fill('#a1aab2'),
        },
      },
    },
    tooltip: {
      x: {
        format: 'dd/MM/yy',
      },
      theme: 'dark',
    },
    legend: {
      labels: {
        colors: ['#a1aab2'],
      },
    },
  };

  return (
    <div id="speciality-area-spline" className="w-full h-96">
      <Chart options={options} series={series} type="area" height="100%" />
    </div>
  );
};

export default SpecialityAreaChart;
